import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from '../config';

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (!email || !email.includes("@")) {
      setErrorMsg("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email });
      if (res.status === 200) {
        setSuccessMsg(res.data?.message || "If an account exists, a reset link has been sent to the email provided.");
      }
    } catch (err) {
      const serverMsg = err.response?.data?.message;
      setErrorMsg(serverMsg || err.message || "Unable to process request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section style={{ margin: "3rem 5rem" }}>
      <h1 className="centered-subtitle">Forgot Password</h1>
      <section className="log-in-container">
        <form className="log-in-form" onSubmit={handleSubmit}>
          {errorMsg && <div className="log-in-error">* {errorMsg}</div>}
          {successMsg && <div className="log-in-success">* {successMsg}</div>}

          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />

          <button type="submit" disabled={loading}>{loading ? 'Sending reset link...' : 'Send Reset Link'}</button>

          <p>Remembered your password? <Link to="/log-in">Log In</Link></p>
        </form>
      </section>
    </section>
  );
}

export default ForgotPassword;
